import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICurrency } from "src/types/currency";
import { IBetHighlightAmount } from 'src/types/settings';


type ICurrencySlice = {
    currencies : ICurrency[],
    betHighlightAmount : IBetHighlightAmount[]
    highlightColor : string
}

const initialState: ICurrencySlice = {
    currencies:[],
    betHighlightAmount:[],
    highlightColor: "#e96262",
};

export const currencySlice = createSlice({
    name:"currencies",
    initialState,
    reducers:{
        updateCurrencies:(state,action:PayloadAction<ICurrency[]>) =>{
            state.currencies = action.payload;
        },
        setBetHighlightAmount:(state,action:PayloadAction<IBetHighlightAmount[]>) =>{
            state.betHighlightAmount = action.payload;
        },
    }
})


export const { updateCurrencies, setBetHighlightAmount } = currencySlice.actions;

export default currencySlice.reducer;
